import React from 'react';
import { Link } from '@tanstack/react-router';
// Add icons for link boxes
import { UserGroupIcon, BriefcaseIcon, ChartBarIcon, CurrencyDollarIcon, CubeIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import Breadcrumbs from '../../components/Breadcrumbs'; // Import Breadcrumbs

const AdminIndexPage = () => {
    const crumbs = [
        { label: 'Admin' } // Current page
    ];

    return (
        <div className="text-foreground">
            <Breadcrumbs crumbs={crumbs} />

            <h1 className="text-2xl font-semibold mb-4">Admin dashboard</h1>
            <p className="mb-6 text-muted-foreground">Manage users, view jobs, and see analytics.</p>

            {/* Quick Links */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                <Link
                    to="/app/admin/users"
                    className="bg-background-elevated border border-border p-6 rounded hover:bg-surface-hover transition-colors flex flex-col items-center justify-center text-center"
                >
                    <UserGroupIcon className="w-10 h-10 mb-2 text-accent" />
                    <h2 className="text-xl font-semibold">Users</h2>
                </Link>
                <Link
                    to="/app/admin/jobs"
                    className="bg-background-elevated border border-border p-6 rounded hover:bg-surface-hover transition-colors flex flex-col items-center justify-center text-center"
                >
                    <BriefcaseIcon className="w-10 h-10 mb-2 text-accent" />
                    <h2 className="text-xl font-semibold">Jobs</h2>
                </Link>
                <Link
                    to="/app/admin/generation-jobs"
                    className="bg-background-elevated border border-border p-6 rounded hover:bg-surface-hover transition-colors flex flex-col items-center justify-center text-center"
                >
                    <CubeIcon className="w-10 h-10 mb-2 text-accent" />
                    <h2 className="text-xl font-semibold">3D Jobs</h2>
                </Link>
                <Link
                    to="/app/admin/analytics"
                    className="bg-background-elevated border border-border p-6 rounded hover:bg-surface-hover transition-colors flex flex-col items-center justify-center text-center"
                >
                    <ChartBarIcon className="w-10 h-10 mb-2 text-accent" />
                    <h2 className="text-xl font-semibold">Analytics</h2>
                </Link>
                <Link
                    to="/app/admin/revenue-projections"
                    className="bg-background-elevated border border-border p-6 rounded hover:bg-surface-hover transition-colors flex flex-col items-center justify-center text-center"
                >
                    <CurrencyDollarIcon className="w-10 h-10 mb-2 text-accent" />
                    <h2 className="text-xl font-semibold">Revenue Projections</h2>
                </Link>
                <Link
                    to="/app/admin/conversion-projections"
                    className="bg-background-elevated border border-border p-6 rounded hover:bg-surface-hover transition-colors flex flex-col items-center justify-center text-center"
                >
                    <UserGroupIcon className="w-10 h-10 mb-2 text-accent" />
                    <h2 className="text-xl font-semibold">Conversion Projections</h2>
                </Link>
                <Link
                    to="/app/admin/email-marketing"
                    className="bg-background-elevated border border-border p-6 rounded hover:bg-surface-hover transition-colors flex flex-col items-center justify-center text-center"
                >
                    <EnvelopeIcon className="w-10 h-10 mb-2 text-accent" />
                    <h2 className="text-xl font-semibold">Email Marketing</h2>
                </Link>
            </div>
        </div>
    );
};

export default AdminIndexPage; 